export default "__VITE_ASSET__d896c0bb__"